import React from "react"
import { ResponsiveBar } from "@nivo/bar"
import ChartCard from "@react/projects/chantiers_dashboard/components/ChartCard"
import { PALETTE, NIVO_THEME, formatShort } from "@react/projects/chantiers_dashboard/components/palette"

// extrapolation unique se lit comme une promesse :
const COLORS = { actual: PALETTE.indigo, floor: "#cbd5e1", trend: PALETTE.emerald }

const ProjectionChart = ({ data, currency }) => {
  const rows = data?.rows || []

  const money = (value) =>
    new Intl.NumberFormat(I18n.locale || "fr", {
      style: "currency", currency: currency || "EUR", maximumFractionDigits: 0,
    }).format(value || 0)

  const label = {
    actual: I18n.t("contracts_dashboard.projection.actual"),
    floor:  I18n.t("contracts_dashboard.projection.floor"),
    trend:  I18n.t("contracts_dashboard.projection.trend"),
  }

  const hasTrend = data?.cagr != null

  const bars = rows.map((row) => ({
    period: row.label,
    [label.actual]: row.forecast ? null : row.actual / 100,
    [label.floor]:  row.forecast ? row.floor / 100 : null,
    [label.trend]:  row.forecast && row.trend != null ? row.trend / 100 : null,
  }))

  const keys = [label.actual, label.floor].concat(hasTrend ? [label.trend] : [])
  const tone = { [label.actual]: COLORS.actual, [label.floor]: COLORS.floor, [label.trend]: COLORS.trend }

  const subtitle = hasTrend
    ? I18n.t("contracts_dashboard.charts.projection_hint", { cagr: data.cagr, indexation: data.indexation_rate })
    : I18n.t("contracts_dashboard.charts.projection_no_trend")

  return (
    <ChartCard
      icon     = "chart-column"
      title    = {I18n.t("contracts_dashboard.charts.projection")}
      subtitle = {subtitle}
      height   = {340}
      empty    = {bars.length === 0 ? I18n.t("contracts_dashboard.charts.empty") : null}
    >
      <ResponsiveBar
        data         = {bars}
        keys         = {keys}
        indexBy      = "period"
        groupMode    = "grouped"
        margin       = {{ top: 24, right: 26, bottom: 56, left: 78 }}
        padding      = {0.32}
        innerPadding = {2}
        colors       = {({ id }) => tone[id]}
        borderRadius = {2}
        enableLabel  = {false}
        axisLeft     = {{ tickSize: 0, tickPadding: 8, format: (v) => formatShort(v * 100) }}
        axisBottom   = {{ tickSize: 0, tickPadding: 9 }}
        theme        = {NIVO_THEME}
        legends      = {[{
          dataFrom: "keys", anchor: "bottom", direction: "row", translateY: 48,
          // se chevauchent.
          itemWidth: 215, itemHeight: 16, itemsSpacing: 4,
          symbolSize: 9, symbolShape: "circle",
        }]}
        tooltip = {({ id, value, indexValue }) => (
          <div style={{ background: "#0f172a", color: "#fff", padding: "7px 11px", fontSize: 11, borderRadius: 6 }}>
            <strong>{indexValue}</strong> · {id}
            <div style={{ marginTop: 2 }}>{money(value)}</div>
          </div>
        )}
      />
    </ChartCard>
  )
}

export default ProjectionChart
